import React, {Component} from 'react';
import Chart from "chart.js";
import Api from "../../../libraries/api";
import {CircularProgress} from "@material-ui/core";

class ChartTotalUsers extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
        this.state = {
            period: 'weekly',
            loading: false,
            totalUsers: ''
        };
        this.getUserChart('weekly')
        this.handleChange = this.handleChange.bind(this);
        this.getUserChart = this.getUserChart.bind(this);
    }

    kFormatter(num) {
        return Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num)
    }

    getUserChart(period) {
        Api.get('/reports/register-users?period=' + period, true).then(resp => {
            if (resp.data) {
                let labels = resp.data["registerUsers"]["columns"];
                let users = resp.data["registerUsers"]["users"];
                let total = this.kFormatter(resp.data["registerUsers"]["total"]);
                this.setState({loading: false, totalUsers: total})
                this.__chart(labels, users)
            }
        }).catch(err => {
            console.log(err);
        });
    }

    __chart = (labels, users) => {
        var barChartData = {
            labels: labels,
            datasets: [{
                label: 'Users',
                backgroundColor: '#008299',
                borderColor: '#008299',
                borderWidth: 1,
                hiddenLegend: true,
                datalabels: {
                    color: 'transparent'
                },
                data: users
            }]
        };
        let myChartRef = this.chartRef.current.getContext("2d");
        new Chart(myChartRef, {
            type: 'bar',
            data: barChartData,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },
                legend: {
                    position: 'top',
                },
            }
        }).update();
    }

    handleChange = (target, prop) => {
        this.setState({period: target, loading: true}, () => {
            this.getUserChart(target)
        });
    };

    render() {
        return (
            <div>
                <div className="row" style={{margin:'26px 10px 0px -15px'}}>
                    <div className=" card col-md-12 col-lg-12" style={{padding:'20px 20px 0px 20px'}}>
                        <div className="row title-dashboard">
                            <div className="col-6" >
                                <h2>Total Users</h2>
                            </div>
                        </div>
                        <div className="d-md-flex justify-content-center mt-4 mb-4">
                            <nav className="nav nav-filter">
                                <button className={"nav-link pl-0 " + (this.state.period === 'daily' && 'active')}
                                        onClick={() => this.handleChange('daily', 'period')}>Daily
                                </button>
                                <button className={"nav-link " + (this.state.period === 'weekly' && 'active')}
                                        onClick={() => this.handleChange('weekly', 'period')}>Weekly
                                </button>
                                <button className={"nav-link " + (this.state.period === 'monthly' && 'active')}
                                        onClick={() => this.handleChange('monthly', 'period')}>Monthly
                                </button>
                            </nav>
                        </div>
                        <ShowUsersChart loading={this.state.loading} chartRef={this.chartRef}/>
                    </div>
                </div>
            </div>
        )
    }
}

class ShowUsersChart extends Component {
    render() {
        if (this.props.loading === true) {
            return <CircularProgress/>
        } else {
            return (
                <div className="chart-container">
                    <canvas id="myChart" ref={this.props.chartRef}/>
                </div>
            )
        }
    }
}


export default ChartTotalUsers;